import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { PropertyApplicationStatus } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';

import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';
import { BANNER_CONFIGS } from './property-banner.config';

@Component({
  selector: 'app-property-banner',
  templateUrl: './property-banner.component.html',
  styleUrls: ['./property-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ImmomioTooltipDirective, TranslatePipe]
})
export class PropertyBannerComponent {
  readonly applicantStatus = input<string>(undefined);
  readonly showExplanation = input(false);

  get bannerInfo() {
    return BANNER_CONFIGS[
      this.applicantStatus() || PropertyApplicationStatus.NEW_MATCH
    ];
  }
}
